import React from "react";

import { View, StyleSheet, Text } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  radioGroup: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  radio: {
    backgroundColor: "#f8f9fb",
    height: "4mm",
    width: "4mm",
    border: "1pt solid #E5E9F0",
    borderRadius: "9999pt",
  },
  radioLabel: {
    paddingLeft: "2mm",
    color: "#2E3440",
  },
});

type RadioProps = {
  label: string;
};

const Radio: React.FC<RadioProps> = ({ label }) => (
  <View style={styles.radioGroup}>
    <View style={styles.radio} />
    <Text style={styles.radioLabel}>{label}</Text>
  </View>
);

export default Radio;
